import * as a from "react";
const l = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M16.925 3.5H7.13A1.13 1.13 0 006 4.63v15.762a.754.754 0 001.243.566l1.673-1.432a.196.196 0 01.233 0l2.427 1.823a.753.753 0 00.904 0l2.426-1.823a.196.196 0 01.233 0l1.673 1.431a.754.754 0 001.243-.565V4.63a1.13 1.13 0 00-1.13-1.13zm-1.507 9.418a.565.565 0 110-1.13.565.565 0 010 1.13zm.565 2.449a.565.565 0 11-1.13 0 .565.565 0 011.13 0zm-.565-5.651a.565.565 0 110-1.13.565.565 0 010 1.13zM8.26 12.918a.565.565 0 010-1.13h4.521a.565.565 0 110 1.13h-4.52zm3.956 2.449a.565.565 0 01-.565.565H8.26a.565.565 0 010-1.13h3.39a.572.572 0 01.565.565zM7.696 9.15a.573.573 0 01.564-.565h4.144a.565.565 0 010 1.13H8.26a.565.565 0 01-.565-.565z",
      fill: "#2d6ded"
    }
  )
), t = l;
export {
  t as default
};
